import { release } from "../../../release";

export const Footer = () => (
  <footer className="footer">
    <div className="footer-text">Version {release}</div>
  </footer>
);
